<template>
    <div class="loginbox">
        <input type="text" v-model="username" placeholder="请输入账号" />
        <input type="password" v-model="password" placeholder="请输入密码" />
        <button @click="login">登录</button>
    </div>
</template>

<script>
export default {
    props: {},
    data() {
        return {
            username: '',
            password: ''
        };
    },
    computed: {},
    created() {},
    mounted() {
        this.loginOut();
    },
    watch: {},
    methods: {
        loginOut() {
            this.$http.ajax({ method: 'get', url: 'auth/logout' }).then((res) => {
                // this.$router.push({ name: 'index' });
            });
        },
        login() {
            this.$http.ajax({ method: 'post', url: 'auth/login', data: { username: this.username, password: this.password } }).then((res) => {
                this.$router.push({ name: 'index' });
            });
        }
    },
    components: {}
};
</script>
<style scoped lang="scss">
.loginbox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: auto;
    background: rgba($color: #003a6a, $alpha: 0.6);
    border-radius: 8px;
    padding: 30px;
    text-align: center;
    input {
        display: block;
        width: 300px;
        height: 40px;
        line-height: 40px;
        border: none;
        border-radius: 4px;
        background: rgba($color: #000304, $alpha: 0.3);
        box-sizing: border-box;
        padding: 10px;
        color: #ffffff;
        &:nth-of-type(1) {
            margin-bottom: 20px;
        }
    }
    button {
        margin: 20px auto;
        display: block;
        width: 300px;
        height: 40px;
        border: none;
        font-size: 18px;
        background: #003a6a;
        color: #ffffff;
        font-weight: bold;
    }
}
</style>
